import { onDocumentReady } from '@src/scripts/lib/event';
import { trackGtmEvent } from '@src/scripts/lib/gtm';

type Props = {
	category: string;
	filter_study_format: string | undefined; // eslint-disable-line camelcase
	filter_graduation_level: string | undefined; // eslint-disable-line camelcase
	filter_study_topic: string | undefined; // eslint-disable-line camelcase
	filter_study_location: string | undefined; // eslint-disable-line camelcase
	filter_study_language: string | undefined; // eslint-disable-line camelcase
};

const nameToPropMap: { [ key: string ]: keyof Props } = {
	abschlussart: 'filter_graduation_level',
	themenwelt: 'filter_study_topic',
};

onDocumentReady( () => {
	window.onload = () => {
		const studyFinderBlock = document.querySelector(
			'.dhsv-find-your-study-block'
		);
		const mobileStudyFilter = document.querySelector(
			'.mobile-study-filter-overlay'
		);

		trackStudyFinderDesktop( studyFinderBlock );
		trackStudyFinderMobile( mobileStudyFilter );
	};
} );

const trackStudyFinderDesktop = ( studyFinderBlock: any ) => {
	if ( studyFinderBlock ) {
		const submitButton = studyFinderBlock.querySelector( 'button.submit' );

		if ( submitButton ) {
			submitButton.addEventListener( 'click', () => {
				const dataLayerObject: Props = {
					category: 'filter_usage',
					filter_study_format: 'Fernstudium',
					filter_graduation_level: undefined,
					filter_study_topic: undefined,
					filter_study_location: undefined,
					filter_study_language: undefined,
				};

				const filters = studyFinderBlock.querySelectorAll(
					'.study-filter-item'
				);

				if ( filters && filters.length > 0 ) {
					filters.forEach( ( filter: any ) => {
						const value = filter.querySelector( '.value' );
						const { name } = filter.querySelector(
							'.label'
						).dataset;

						const isPlaceholder = value.classList.contains(
							'placeholder'
						);

						if ( ! isPlaceholder ) {
							const prop = nameToPropMap[ name ];
							dataLayerObject[ prop ] = dataLayerObject[ prop ]
								? `${ dataLayerObject[ prop ] }, ${ value.textContent }`
								: value.textContent;
						}
					} );
				}

				trackGtmEvent( 'ga_event', dataLayerObject, true );
			} );
		}
	}
};

const trackStudyFinderMobile = ( mobileStudyFilter: any ) => {
	if ( mobileStudyFilter ) {
		const submitButton = mobileStudyFilter.querySelector(
			'button[type="submit"]'
		);

		if ( submitButton ) {
			submitButton.addEventListener( 'click', () => {
				const dataLayerObject: Props = {
					category: 'filter_usage',
					filter_study_format: 'Fernstudium',
					filter_graduation_level: undefined,
					filter_study_topic: undefined,
					filter_study_location: undefined,
					filter_study_language: undefined,
				};

				const filters = mobileStudyFilter.querySelectorAll(
					'.filter-item'
				);

				if ( filters && filters.length > 0 ) {
					filters.forEach( ( filter: any ) => {
						const filterButton = filter.querySelector( 'button' );
						const name = filterButton.querySelector( '.label' )
							?.dataset?.name;
						const value = filterButton.querySelector( '.value' )
							?.textContent;

						if ( name && value ) {
							const prop = nameToPropMap[ name ];
							dataLayerObject[ prop ] = dataLayerObject[ prop ]
								? `${ dataLayerObject[ prop ] }, ${ value }`
								: value;
						}
					} );
				}

				trackGtmEvent( 'ga_event', dataLayerObject, true );
			} );
		}
	}
};
